import React, { useState, useEffect } from 'react';
import { Modal, Select, Input, Button, Row } from 'antd';
import { useSpace } from '../../hooks/useSpace';
import { useSpaceContent } from '../../hooks/useSpaceContent';
import httpInjectorService from 'services/http-injector.service';

export default function DuplicateModal({
  open,
  onClose,
  originalNode,
  onConfirm,
  spaceid,
}) {
  //console.log('originalNode:', originalNode);
  const [step, setStep] = useState(1);
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [selectedParent, setSelectedParent] = useState(null);
  const [prefix, setPrefix] = useState('');
  const [copyChildren, setCopyChildren] = useState(true);
  const [spaces, setSpaces] = useState([]);

  const { data: targetContent } = useSpaceContent(selectedSpace);

  const handleNext = () => {
    if (step === 1 && !selectedSpace) return;
    setStep(step + 1);
  };

  useEffect(() => {
    if (open) {
      getSpaces();
      setSelectedSpace(Number(spaceid));
    }
  }, [open]);

  const getSpaces = async () => {
    try {
      const response = await httpInjectorService.getSpaces({
        filter_type: 'All_Spaces',
        category_id: null,
      });
      if (response.status === 'success') {
        setSpaces(response.data);
      }
    } catch (error) {
      console.error('Error fetching spaces:', error);
    }
  };

  const handleDuplicate = () => {
    onConfirm({
      original_id: originalNode.item_id,
      target_space_id: selectedSpace,
      parent_id: selectedParent,
      prefix,
        is_child: copyChildren,
    });
    handleReset();
  };

  const handleReset = () => {
    setStep(1);
    setSelectedParent(null);
    setPrefix('');
    setCopyChildren(true);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleReset}
      footer={null}
      title="Duplicate Content"
      width={500}
      zIndex={2000}
    >
      {step === 1 && (
        <>
          <div style={{ marginBottom: 16 }}>
            <label>Select Space</label>
            <Select
              value={selectedSpace}
              style={{ width: '100%', marginTop: 6 }}
              placeholder="Select Space"
              onChange={(val) => {
                setSelectedSpace(val);
                setSelectedParent(null);
              }}
              options={spaces.map((s) => ({
                label: s.space_name,
                value: s.space_id,
              }))}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label>Parent (Optional)</label>
            <Select
              style={{ width: '100%', marginTop: 6 }}
              placeholder="No Parent"
              allowClear
              onChange={setSelectedParent}
              options={
                targetContent
                  ?.filter(
                    (item) =>
                      item.item_type === 'folder' ||
                      item.item_type === 'template' ||
                      (item.item_type === 'page' &&
                        item.status === 'published'),
                  )
                  .map((item) => ({
                    label: item.title,
                    value: item.item_id,
                  })) || []
              }
            />
          </div>

          <Row justify="end">
            <Button
              type="primary"
              onClick={handleNext}
              disabled={!selectedSpace}
              style={{
                background: '#7a3db8',
                border: 'none',
              }}
            >
              Next
            </Button>
          </Row>
        </>
      )}

      {step === 2 && (
        <>
          <div style={{ marginBottom: 16 }}>
            {/* <span>
              Each content type in a space requires a unique title. Since you’re
              duplicating multiple content types at once, you may want to rename
              or revise their titles in bulk.
            </span> */}
            <label>Start all titles with:</label>
            <Input
              style={{ marginTop: 6 }}
              placeholder={`Copy of ${originalNode?.title}`}
              value={prefix}
              onChange={(e) => setPrefix(e.target.value)}
            />
          </div>

          {originalNode?.children?.length > 0 && (
            <div style={{ marginBottom: 16 }}>
              <label>Copy Child Items?</label>
              <Select
                style={{ width: '100%', marginTop: 6 }}
                value={copyChildren}
                onChange={setCopyChildren}
                options={[
                  { label: 'Yes - Copy all child content', value: true },
                  { label: 'No - Only duplicate this item', value: false },
                ]}
              />
            </div>
          )}

          <Row justify="space-between">
            <Button onClick={() => setStep(1)}>Back</Button>
            <Button
              type="primary"
              onClick={handleDuplicate}
              style={{
                background: '#7a3db8',
                border: 'none',
              }}
            >
              Duplicate
            </Button>
          </Row>
        </>
      )}
    </Modal>
  );
}
